module.exports = __webpack_public_path__ + "img/Recurso 3@300x.fb6b3f97.webp";